<template>
    <div class="search-results">
        <div v-if="showCategories" class="categories">
            <div v-if="!isMobile" class="categories-groups">
                <div
                    v-for="category in categoriesGroups"
                    :key="category.id"
                    class="categories-column"
                >
                    <div
                        v-for="item in category.items"
                        :key="item.id"
                        class="categories-item"
                    >
                        <ModelCheckbox
                            :label="item.label"
                            :input-value="item.value"
                            @change="selectCategoryHandler(category.id, item.id, $event)"
                        />
                    </div>
                </div>
            </div>
            <div v-else class="categories-groups">
                <div class="categories-column">
                    <div
                        v-for="category in leftCategories"
                        :key="category.id"
                        class="categories-group-item"
                    >
                        <div
                            v-for="item in category.items"
                            :key="item.id"
                            class="categories-item"
                        >
                            <ModelCheckbox
                                :label="item.label"
                                :input-value="item.value"
                                @change="selectCategoryHandler(category.id, item.id, $event)"
                            />
                        </div>
                    </div>
                </div>
                <div class="categories-column">
                    <div
                        v-for="category in rightCategories"
                        :key="category.id"
                        class="categories-group-item"
                    >
                        <div
                            v-for="item in category.items"
                            :key="item.id"
                            class="categories-item"
                        >
                            <ModelCheckbox
                                :label="item.label"
                                :input-value="item.value"
                                @change="selectCategoryHandler(category.id, item.id, $event)"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="searchReceived" class="info">
            <div class="info-text">
                {{ `${ strFound } ${ searchCount } ${ strResults }` }}
            </div>
            <div
                class="info-clear-button"
                @click="clearSearchHandler"
            >
                Очистить запрос
            </div>
        </div>
        <div class="results">
            <SearchResult
                v-for="(item, index) in searchItems"
                :key="item.id || index"
                :item="item"
                :search="search"
                @navigate="$emit('navigate')"
            />
        </div>
    </div>
</template>

<script>
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import SearchResult from './SearchResult';
import { getCategoriesGroups } from './SearchCategories';
import { getFormattedDate } from '@/tools/moment-date';
import str_counter from '@/tools/str_counter';
import { mapGetters } from 'vuex';

const getters = [
    'isMobile',
    'searchItems',
    'searchCount',
    'searchReceived',
];


export default {
    name: "SearchResults",

    components: {
        ModelCheckbox,
        SearchResult,
    },

    props: {
        showCategories: {
            type: Boolean,
            default: false,
        },

        search: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            categoriesGroups: getCategoriesGroups(),
        };
    },

    computed: {
        ...mapGetters(getters),

        strFound() {
            return this.countFound(this.searchCount);
        },

        strResults() {
            return this.countResults(this.searchCount);
        },

        showContent() {
            return this.showCategories || this.searchReceived;
        },

        leftCategories() {
            return this.categoriesGroups.filter(el => el.mobileLeft);
        },

        rightCategories() {
            return this.categoriesGroups.filter(el => !el.mobileLeft);
        },
    },

    methods: {
        countFound: str_counter('Найден', '', 'о', 'о'),
        countResults: str_counter('результат', '', 'а', 'ов'),

        selectCategoryHandler(categoryId, itemId, flag) {
            this.categoriesGroups = this.categoriesGroups.map(category => {
                if (category.id === categoryId) {
                    return {
                        ...category,
                        items: category.items.map(item => {
                            if (item.id === itemId) {
                                return {
                                    ...item,
                                    value: flag,
                                };
                            }
                            return item;
                        }),
                    };
                }
                return category;
            });

            this.$emit('change', this.getSelectedCategories().flat());
        },

        getSelectedCategories() {
            return this.categoriesGroups.reduce((res, curr) => {
                curr.items.forEach(item => {
                    if (item.value) {
                        res = [...res, item.keys];
                    }
                });
                return res;
            }, []);
        },

        clearSearchHandler() {
            this.categoriesGroups = getCategoriesGroups();
            this.$emit('clear');
        },

        getMeta(item) {
            const date = item.date ? getFormattedDate(item.date, 'DD.MM.YYYY') : '';
            return `${this.getField(item.affiliation)}${ date ? ` ${ date }` : '' }`;
        },
    },
};
</script>

<style lang="scss">
    @import "../../styles/rem";

    .search-results {

        label {
            display: flex;
            align-items: flex-start;
        }
        label.labeled {
            margin-bottom: rem(16)!important;

            @include on-md {
                margin-bottom: mdrem(20)!important;
                font-size: mdrem(16);

                &::before {
                    margin-right: mdrem(12)!important;
                }
            }

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
                margin-bottom: mrem(20);

                &::before {
                    margin-right: mrem(12)!important;
                }
            }

            @include on-mobile {
                margin-bottom: mrem(12)!important;
            }

            &::before {
                @include on-md {
                    width: mdrem(18);
                    height: mdrem(18);
                    margin-right: mdrem(8);
                    border: mdrem(2) solid #98A0A9;
                    box-sizing: border-box;
                    border-radius: mdrem(2);
                }

                @include on-mobile {
                    width: mrem(18);
                    height: mrem(18);
                    border: mrem(2) solid #98A0A9;
                    border-radius: mrem(2);
                    margin-right: mrem(8);
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
@import "../../styles/rem";

.search-results {
    width: 100%;
    font-family: 'Proxima Nova', sans-serif;
    background-color: #FFFFFF;

    .categories {
        &-groups {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;

            @include on-mobile {
                justify-content: space-between;
            }
        }

        &-column {
            min-width: rem(150);

            @include on-md {
                width: mdrem(172);
            }

            @include on-mobile {
                width: mrem(172);
            }
        }

        &-group-item {
            margin-bottom: rem(24);
        }
    }

    .info {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        margin-top: rem(16);

        @include on-md {
            margin-top: mdrem(16);
        }

        @include on-mobile {
            margin-top: 0;
        }

        &-text {
            margin-right: rem(16);
            font-size: rem(15);
            line-height: rem(22);
            color: #98A0A9;

            @include on-md {
                margin-right: mdrem(16);
                font-size: mdrem(15);
                line-height: mdrem(22);
            }

            @include on-mobile {
                margin-right: mrem(16);
                font-size: mrem(15);
                line-height: mrem(22);
            }
        }

        &-clear-button {
            font-size: rem(15);
            line-height: rem(22);
            color: #EF627D;
            cursor: pointer;

            &:hover {
                color: #E75671;
            }

            @include on-md {
                font-size: mdrem(15);
                line-height: mdrem(22);
            }

            @include on-mobile {
                font-size: mrem(15);
                line-height: mrem(22);
            }
        }
    }

}
</style>
